var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomizableProductsMenuIcon = function SvgCustomizableProductsMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 1.875A3.137 3.137 0 0 0 6.875 5v.625H3.789l-.039.586-.625 11.25-.04.664h13.83l-.04-.664-.625-11.25-.04-.586h-3.085V5A3.137 3.137 0 0 0 10 1.875m0 1.25c1.035 0 1.875.84 1.875 1.875v.625h-3.75V5c0-1.035.84-1.875 1.875-1.875m-5.04 3.75h1.915V8.75h1.25V6.875h3.75V8.75h1.25V6.875h1.914l.547 10H4.414z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m10.011 9 .923 1.97 2.066.323-1.495 1.53.352 2.177-1.846-1.02L8.143 15l.373-2.178L7 11.293l2.088-.324z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgCustomizableProductsMenuIcon;